module.exports = __webpack_public_path__ + "img/colegio_internacional.65fff33b.png";